export default {
  LocationsPage: {
    pageTitle: 'Locations',
  },
  RegionsPage: {
    pageTitle: 'Regions',
  },
  OfficesPage: {
    pageTitle: 'Offices',
  },
  RegionSelect: {
    selectRegion: 'Select region',
  },
  OfficeSelect: {
    selectOffice: 'Select office',
  },
};
